import { render, staticRenderFns } from "./OfficialAgency.vue?vue&type=template&id=63c6f6da"
import script from "./OfficialAgency.vue?vue&type=script&lang=js"
export * from "./OfficialAgency.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports